import { Input, Select } from '@trackman/web-shared-components';
import { VideoUploadOption } from 'types/admin/trackmanEventsAdmin';

const recordingOptions = [
  { label: 'Video ID', value: 'videoId' },
  { label: 'Video URL', value: 'videoUrl' },
];

export const RecordingSettings = ({
  videoUploadOption,
  videoId,
  videoUrl,
  setVideoUploadOption,
  setVideoId,
  setVideoUrl,
  setPreviewImageData,
}) => {
  const handleVideoSettingsChange = (event) => {
    setVideoUploadOption(event.target.value as VideoUploadOption);
    setPreviewImageData(null);
  };

  return (
    <div className='admin-edit-section'>
      <h2>Recording URL*</h2>
      <div className='inputs-container recording-settings'>
        <Select
          label=''
          value={videoUploadOption}
          className='narrow-select'
          required
          onChange={(event) => handleVideoSettingsChange(event)}
          selectOptions={recordingOptions.map((info) => {
            return {
              label: info.label,
              value: info.value,
            };
          })}
        />
        {videoUploadOption === 'videoId' ? (
          <Input
            label='Video ID'
            value={videoId ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setVideoId(e.currentTarget.value)}
          />
        ) : (
          <Input
            label='Video URL'
            value={videoUrl ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setVideoUrl(e.currentTarget.value)}
          />
        )}
      </div>
    </div>
  );
};
